import { rgSerialise } from './rg-serialise.js';

/** @deprecated: use `rgSerialise` instead
 * remove parent to avoid circular dependencies  */
function serializify(obj) {
    return rgSerialise(obj);
}

export { serializify };
//# sourceMappingURL=serializify.js.map
